module["exports"] = [
  "Sr.",
  "Sra.",
  "Sta."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/name/prefix.js
// module id = 1268
// module chunks = 0